export const gtagAnalyticsEvents = {
	SIGNUP_REQUEST: 'AW-16669044391/bX_lCKOv5ucZEKfdtYw-',
	CREDITS_OVER: 'AW-16669044391/nVizCNrU5ucZEKfdtYw-',
	GENERATE_BUTTON: 'AW-16669044391/2LjsCNfU5ucZEKfdtYw-',
	BEGIN_CHECKOUT: 'AW-16669044391/alz9CN3U5ucZEKfdtYw-',
	PURCHASE_SUCCESSFULL: 'AW-16669044391/yNztCODU5ucZEKfdtYw-',
};
